import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-zinc-950 text-zinc-100">
      <h1 className="text-5xl font-extrabold">404</h1>
      <p className="text-zinc-400">This page doesn’t exist.</p>
      <Link to="/" className="text-fuchsia-400 hover:underline">
        ← Back home
      </Link>
    </div>
  )
}
